import { EntityModel } from '@/interfaces'
import {
  ALL_CONVERSIONS_QUERY,
  CREATE_CONVERSION_MUTATION,
  DELETE_CONVERSION_MUTATION,
  FORCE_DELETE_CONVERSION_MUTATION,
  SINGLE_CONVERSION_QUERY,
  UPDATE_CONVERSION_MUTATION,
} from './graphql'
import tenantEntity from '@/entities/tenant/entity'

const trackingConversionModel: EntityModel = {
  name: 'conversion',
  namePlural: 'conversions',
  uniqueName: 'trackingConversion',
  uniqueNamePlural: 'trackingConversions',
  path: 'tracking/conversion',
  baseUrl: '/tracking/conversions',
  translationPrefix: 'entities:trackingConversion.',
  getDisplayName: (values: any) => {
    return ''
  },
  gql: {
    getAll: ALL_CONVERSIONS_QUERY,
    getSingle: SINGLE_CONVERSION_QUERY,
    create: CREATE_CONVERSION_MUTATION,
    update: UPDATE_CONVERSION_MUTATION,
    delete: DELETE_CONVERSION_MUTATION,
    forceDelete: FORCE_DELETE_CONVERSION_MUTATION,
  },
  attributes: {
    sessionId: {
      name: 'sessionId',
      label: 'entities:trackingConversion.attributes.sessionId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    conversionName: {
      name: 'conversionName',
      label: 'entities:trackingConversion.attributes.conversionName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    conversionTime: {
      name: 'conversionTime',
      label: 'entities:trackingConversion.attributes.conversionTime.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    conversionValue: {
      name: 'conversionValue',
      label: 'entities:trackingConversion.attributes.conversionValue.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    conversionCurrency: {
      name: 'conversionCurrency',
      label: 'entities:trackingConversion.attributes.conversionCurrency.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    tourName: {
      name: 'tourName',
      label: 'entities:trackingConversion.attributes.tourName.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    tourId: {
      name: 'tourId',
      label: 'entities:trackingConversion.attributes.tourId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    bookingId: {
      name: 'bookingId',
      label: 'entities:trackingConversion.attributes.bookingId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    landingPageUrl: {
      name: 'landingPageUrl',
      label: 'entities:trackingConversion.attributes.landingPageUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    source: {
      name: 'source',
      label: 'entities:trackingConversion.attributes.source.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    medium: {
      name: 'medium',
      label: 'entities:trackingConversion.attributes.medium.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    utmSource: {
      name: 'utmSource',
      label: 'entities:trackingConversion.attributes.utmSource.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    utmMedium: {
      name: 'utmMedium',
      label: 'entities:trackingConversion.attributes.utmMedium.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    utmCampaign: {
      name: 'utmCampaign',
      label: 'entities:trackingConversion.attributes.utmCampaign.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    utmTerm: {
      name: 'utmTerm',
      label: 'entities:trackingConversion.attributes.utmTerm.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    utmContent: {
      name: 'utmContent',
      label: 'entities:trackingConversion.attributes.utmContent.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    gclid: {
      name: 'gclid',
      label: 'entities:trackingConversion.attributes.gclid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    gbraid: {
      name: 'gbraid',
      label: 'entities:trackingConversion.attributes.gbraid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    msclkid: {
      name: 'msclkid',
      label: 'entities:trackingConversion.attributes.msclkid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    fbclid: {
      name: 'fbclid',
      label: 'entities:trackingConversion.attributes.fbclid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    ttclid: {
      name: 'ttclid',
      label: 'entities:trackingConversion.attributes.ttclid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    scclid: {
      name: 'scclid',
      label: 'entities:trackingConversion.attributes.scclid.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    liFatId: {
      name: 'liFatId',
      label: 'entities:trackingConversion.attributes.liFatId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    acquisitionTimestamp: {
      name: 'acquisitionTimestamp',
      label: 'entities:trackingConversion.attributes.acquisitionTimestamp.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    tenant: {
      name: 'tenant',
      label: 'entities:trackingConversion.attributes.tenant.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return tenantEntity
      },
      defaultInput: true,
      inputType: 'select',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default trackingConversionModel
